import { useId } from 'react';

import styles from '../WatchlistInsightsSkeleton.module.css';

const axisLabelWidths = [36, 32, 32, 32, 32, 32, 32, 28];

const CHART_AREA_PATH =
  'M0 198 V172 C55 168 110 152 165 158 C220 164 275 142 330 148 C385 154 440 128 495 134 C550 140 605 114 660 104 C715 94 770 72 825 58 C880 44 935 30 1000 22 V198 Z';

const CHART_LINE_PATH =
  'M0 172 C55 168 110 152 165 158 C220 164 275 142 330 148 C385 154 440 128 495 134 C550 140 605 114 660 104 C715 94 770 72 825 58 C880 44 935 30 1000 22';

export const HistoryChartSkeleton = () => {
  const chartId = useId().replace(/:/g, '');

  return (
    <div
      className="relative h-[220px] overflow-hidden bg-bzblue-700"
      aria-busy="true"
      aria-label="Loading performance chart"
      role="status"
    >
      <svg
        className="absolute inset-x-0 top-0 h-[198px] w-full"
        viewBox="0 0 1000 198"
        preserveAspectRatio="none"
        aria-hidden
      >
        <defs>
          <clipPath id={`${chartId}-area-clip`}>
            <path d={CHART_AREA_PATH} />
          </clipPath>
          <linearGradient id={`${chartId}-area-fill`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#00d8ff" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#00d8ff" stopOpacity="0.18" />
          </linearGradient>
          <linearGradient
            id={`${chartId}-shimmer`}
            gradientUnits="userSpaceOnUse"
            x1="-400"
            y1="0"
            x2="400"
            y2="0"
          >
            <stop offset="0%" stopColor="white" stopOpacity="0" />
            <stop offset="50%" stopColor="white" stopOpacity="0.22" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
            <animateTransform
              attributeName="gradientTransform"
              type="translate"
              values="-600 0; 1600 0"
              dur="2s"
              repeatCount="indefinite"
            />
          </linearGradient>
        </defs>

        <path className={styles.historyArea} d={CHART_AREA_PATH} fill={`url(#${chartId}-area-fill)`} />
        <g clipPath={`url(#${chartId}-area-clip)`}>
          <rect
            className={styles.historyShimmer}
            x="0"
            y="0"
            width="1000"
            height="198"
            fill={`url(#${chartId}-shimmer)`}
          />
        </g>
        <path
          className={styles.historyLine}
          d={CHART_LINE_PATH}
          fill="none"
          stroke="#00d8ff"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
      </svg>

      <div className="absolute inset-x-0 bottom-0 flex items-center justify-between px-3 pb-2 pt-1" aria-hidden>
        {axisLabelWidths.map((width, index) => (
          <div
            key={index}
            className={`${styles.bone} h-2.5 rounded-sm`}
            style={{ width, animationDelay: `${index * 80}ms` }}
          />
        ))}
      </div>

      <span className="sr-only">Loading performance chart</span>
    </div>
  );
};
